import { ProductScreenshot } from 'components/ProductScreenshot';
import PersonsFeatureFlagLight from "../../../../contents/images/docs/feature-flags/persons-feature-flag-tab-light-mode.png";
import PersonsFeatureFlagDark from "../../../../contents/images/docs/feature-flags/persons-feature-flag-tab-dark-mode.png";
import BehavioralCohortsLight from "../../../../contents/images/docs/feature-flags/behavioral-cohorts-light-mode.png";
import BehavioralCohortsDark from "../../../../contents/images/docs/feature-flags/behavioral-cohorts-dark-mode.png";
import DeuplicateAsStaticCohortLight from "../../../../contents/images/docs/feature-flags/duplicate-as-static-cohort-light-mode.png";
import DeuplicateAsStaticCohortDark from "../../../../contents/images/docs/feature-flags/duplicate-as-static-cohort-dark-mode.png";
import FAQFalseOrNoneEvents from "../../../../contents/docs/feature-flags/snippets/faq-false-or-none-events.mdx";
import * as React from 'react';
export default {
  ProductScreenshot,
  PersonsFeatureFlagLight,
  PersonsFeatureFlagDark,
  BehavioralCohortsLight,
  BehavioralCohortsDark,
  DeuplicateAsStaticCohortLight,
  DeuplicateAsStaticCohortDark,
  FAQFalseOrNoneEvents,
  React
};